import React from 'react';
import '../../styles/MobileScreener.css';

/**
 * Compact row with Group by Ticker toggle and Sort dropdown
 * Cleaner design with On/Off toggle style
 */
const ViewOptionsRow = ({
  isGrouped,
  setIsGrouped,
  sortBy,
  setSortBy
}) => {
  return (
    <div className="view-options-row">
      {/* Left side: Group by Ticker Toggle */}
      <div className="view-group-toggle">
        <span className="view-group-label">Group by Ticker</span>
        <div className="view-toggle-switch">
          <button
            className={`view-toggle-option ${isGrouped ? 'active' : ''}`}
            onClick={() => setIsGrouped(true)}
          >
            On
          </button>
          <button
            className={`view-toggle-option ${!isGrouped ? 'active' : ''}`}
            onClick={() => setIsGrouped(false)}
          >
            Off
          </button>
        </div>
      </div>

      {/* Right side: Sort Dropdown */}
      <div className="view-sort-wrapper">
        <span className="view-sort-label">Sort:</span>
        <select
          className="view-sort-select"
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
        >
          <option value="gain">Gain %</option>
          <option value="expiration">Expiration</option>
        </select>
      </div>
    </div>
  );
};

export default ViewOptionsRow;
